export default __webpack_public_path__ + "media/c47b48b5aa17394510aaa0378469595bc76de2be7e26a1ff2fcb28a09609908c.svg";